export default {
  default: {
    select: {
      option: 'Select ...',
    },
  },
}
